/** @format */
import { ButtonSkeleton } from '@mpb-com/feather/components/atoms/button/skeleton';
import { HeadingSkeleton } from '@mpb-com/feather/components/atoms/heading/skeleton';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import React from 'react';

import { ConstrainedWrapper } from '@toucan/client/shared/components/constrained-wrapper';

import { VideoBlockSkeletonProps } from '../types';
import { StyledVideoBlockSkeleton } from './skeleton.styles';

export const VideoBlockSkeleton = ({
    'data-testid': dataTestId,
}: VideoBlockSkeletonProps) => {
    return (
        <StyledVideoBlockSkeleton data-testid={dataTestId}>
            <ConstrainedWrapper>
                <div className="video">
                    <Skeleton
                        className="video-skeleton"
                        variant={SkeletonVariant.BLOCK}
                    />
                </div>
                <div className="content">
                    <HeadingSkeleton
                        className="heading"
                        size={HeadingSize.H2}
                    />
                    <Skeleton
                        className="description"
                        variant={SkeletonVariant.TEXT}
                        lineCount={5}
                    />
                    <div className="call-to-action-container">
                        <ButtonSkeleton />
                        <ButtonSkeleton />
                    </div>
                </div>
            </ConstrainedWrapper>
        </StyledVideoBlockSkeleton>
    );
};
